import { AppLayout } from "@bcc/components/app-layout";
import { LabelsView } from "@bcc/components/views/labels-view";

interface TemplateData {
  id: number;
  name: string;
  description: string;
  icon: string;
  uses: number;
}

interface RecentLabelData {
  id: number;
  product: string;
  template: string;
  quantity: number;
  date: string;
  status: "printed" | "ready";
}

const templatesData: TemplateData[] = [
  {
    id: 1,
    name: "Standard Label",
    description: "Classic label for retail packaging",
    icon: "Tag",
    uses: 1240,
  },
  {
    id: 2,
    name: "Premium Label",
    description: "Premium finish with metallic accents",
    icon: "Sparkles",
    uses: 856,
  },
  {
    id: 3,
    name: "Bulk Label",
    description: "High-volume label for wholesale orders",
    icon: "Package",
    uses: 2145,
  },
  {
    id: 4,
    name: "Custom Label",
    description: "Fully customizable label design",
    icon: "Palette",
    uses: 543,
  },
];

const recentLabelsData: RecentLabelData[] = [
  {
    id: 1,
    product: "Ethiopia Yirgacheffe",
    template: "Standard Label",
    quantity: 500,
    date: "2024-12-04",
    status: "printed",
  },
  {
    id: 2,
    product: "Colombia Supremo",
    template: "Premium Label",
    quantity: 250,
    date: "2024-12-03",
    status: "printed",
  },
  {
    id: 3,
    product: "Brazil Santos",
    template: "Bulk Label",
    quantity: 1000,
    date: "2024-12-02",
    status: "ready",
  },
  {
    id: 4,
    product: "Kenya AA",
    template: "Custom Label",
    quantity: 100,
    date: "2024-12-01",
    status: "printed",
  },
];

export function LabelsPage() {
  return (
    <AppLayout>
      <LabelsView templatesData={templatesData} recentLabelsData={recentLabelsData} />
    </AppLayout>
  );
}
